import type { IObservableArray } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Campaign, Targeting } from '@feathr/blackbox';

import AgeDemographics from './AgeDemographics';
import Interests from './Interests';
import Locations from './Locations';
import SelectedFilters from './SelectedFilters';

import * as styles from './AdWizardFiltersStep.css';

interface IProps {
  campaign: Campaign;
  targetings: IObservableArray<Targeting>;
}

function AdWizardFiltersStep({ campaign, targetings }: Readonly<IProps>): JSX.Element {
  const { isOmniCampaign } = campaign;

  return (
    <div className={styles.root} data-name={'filters_step'}>
      {isOmniCampaign ? (
        <>
          <div className={styles.left}>
            <Locations campaign={campaign} targetings={targetings} />
            <AgeDemographics campaign={campaign} targetings={targetings} />
            <Interests campaign={campaign} targetings={targetings} />
          </div>

          <div className={styles.right}>
            <SelectedFilters campaign={campaign} targetings={targetings} />
          </div>
        </>
      ) : (
        <Locations campaign={campaign} targetings={targetings} />
      )}
    </div>
  );
}

export default observer(AdWizardFiltersStep);
